import {
  concentrationUnitTypePredicate,
  containerQuantityUnitTypePredicate,
  massUnitTypePredicate,
  molUnitTypePredicate,
  volumeUnitTypePredicate,
} from 'inventory/InventoryUnitUtil';
import {
  stoichiometryAmountUnitTypePredicate,
  stoichiometryConcentrationUnitTypePredicate,
} from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/StoichiometryUnits';

export type UnitTypePredicate = (unitType: object) => boolean;

export enum UnitTypePredicates {
  VOLUME = 'VOLUME',
  CONCENTRATION = 'CONCENTRATION',
  CONTAINER = 'CONTAINER',
  MOL = 'MOL',
  MASS = 'MASS',
  STOICHIOMETRY_AMOUNT = 'STOICHIOMETRY_AMOUNT',
  STOICHIOMETRY_CONCENTRATION = 'STOICHIOMETRY_CONCENTRATION',
}

export const UNIT_TYPE_PREDICATES: {[type in UnitTypePredicates]: UnitTypePredicate} = {
  [UnitTypePredicates.VOLUME]: volumeUnitTypePredicate,
  [UnitTypePredicates.CONCENTRATION]: concentrationUnitTypePredicate,
  [UnitTypePredicates.CONTAINER]: containerQuantityUnitTypePredicate,
  [UnitTypePredicates.MOL]: molUnitTypePredicate,
  [UnitTypePredicates.MASS]: massUnitTypePredicate,
  [UnitTypePredicates.STOICHIOMETRY_AMOUNT]: stoichiometryAmountUnitTypePredicate,
  [UnitTypePredicates.STOICHIOMETRY_CONCENTRATION]: stoichiometryConcentrationUnitTypePredicate,
};

export function getPredicate(type: UnitTypePredicates): UnitTypePredicate {
  return UNIT_TYPE_PREDICATES[type];
}

export function getPredicateType(predicate: UnitTypePredicate): UnitTypePredicates | undefined {
  return Object.values(UnitTypePredicates).find((type) => UNIT_TYPE_PREDICATES[type] === predicate);
}
